<template>
  <div>
    <el-button size="mini" icon="el-icon-plus" @click="toEdit(null)"
      >新增</el-button
    >
    <el-table :data="list_data.list" v-loading="loading" style="width: 100%">
      <el-table-column
        prop="merchant_name"
        label="商户名称"
        min-width="180"
      ></el-table-column>
      <el-table-column
        prop="partner_name"
        label="商户主体"
        width="256"
      ></el-table-column>
      <el-table-column
        prop="merchant_app_id"
        label="商户ID"
        width="222"
      ></el-table-column>
      <el-table-column
        prop="merchant_app_key"
        label="KEY"
        width="222"
      ></el-table-column>
      <el-table-column
        prop="merchant_app_secret"
        label="SECRET"
        width="222"
      ></el-table-column>
      <el-table-column
        prop="merchant_type_label"
        label="平台类型"
        width="100"
      ></el-table-column>
      <el-table-column prop="mode" label="live" width="111">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.mode_bool"
            active-color="#13ce66"
            inactive-color="#aaaaaa"
            @change="setMode(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="statusShow.label" label="启用状态" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status_bool"
            active-color="#13ce66"
            inactive-color="#aaaaaa"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-tag size="mini" class="pointer" @click="toEdit(scope.row)"
            >编辑</el-tag
          >
          <el-tag
            size="mini"
            type="info"
            class="pointer"
            @click="remove(scope.row.id)"
            >删除</el-tag
          >
        </template>
      </el-table-column>
    </el-table>
    <component :is="popName" :item="editItem"></component>
  </div>
</template>
<script>
const edit = (resolve) => require(["@/pages/setting/merchant/_edit"], resolve);
export default {
  components: {
    edit,
  },
  data() {
    return {
      loading: false,
      popName: null,
      editItem: null,
      filter: {},
      list_data: {
        total: 0,
        size: 10,
        list: [],
      },
    };
  },
  methods: {
    toEdit(row = null) {
      if (row) {
        this.editItem = row;
      }
      this.popName = "edit";
    },
    changeStatus(item) {
      this.$http
        .post("/v1/pri/cfg-merchant/set-status", {
          id: item.id,
          status: item.status,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    setMode(item) {
      var mode = item.mode_bool ? 'live' : 'sandbox';
      this.$confirm('确认切换状态:' + mode, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.$http
          .post("/v1/pri/cfg-merchant/set-mode", {
            id: item.id,
            mode: mode,
          })
          .then((response) => {
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          });
      }).catch(() => { 
        this.getList()
      })
    },
    getList() {
      this.loading = true;
      this.$http
        .post("/v1/pri/cfg-merchant/lists", this.filter)
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.list_data = res.data;
          }
        });
    },
    remove(id) {
      this.$confirm("删除商户不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在移除.." });
        this.$http
          .post("/v1/pri/cfg-merchant/remove", { ids: [id] })
          .then((response) => {
            this.$store.commit("setLoading", { text: false });
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "移除成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
          .catch((error) => {
            this.$store.commit("setLoading", { text: false });
          });
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/setting/merchant/_list.vue